import { Route, Routes } from 'react-router'

import { NotFound } from '../common/NotFound'
import Report from './Report'

export const BillingReport = () => {
  return (
    <Routes>
      <Route index element={<Report />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
